export interface INote {
  title: string;
  content: string;
  notableId: string; // the guid you want the note linked to
  identifier: string; // identifier is more for ui purposes and can be anything or null
}

export interface INoteDetail {
  id: string;
  title: string;
  content: string;
  identifier: string;
  notableId: string;
  notableType: string;
  user: {
    id: string;
    name: string;
    surname: string;
  };
  createdAt: string;
  updatedAt: string;
}
